import { ADDON_KIND, ADDON_PRODUCT_KIND, VOICE_ADDONS_KINDS } from '@mfe/shared/constants';

import { addonVisualConfig, VisualConfig } from './config';

type AddonIconType = {
  kind: string;
  className?: string;
};

export const AddonIcon = (props: AddonIconType) => {
  const { kind, className } = props;
  const { icon: Icon, hexColorValue, backgroundColor } = getAddonImagePropsByKind(kind);

  return (
    <div style={{ color: hexColorValue, backgroundColor }} className={className}>
      <Icon width={80} height={80} />
    </div>
  );
};

const config = [
  { config: addonVisualConfig.VOICE, kinds: [ADDON_PRODUCT_KIND.voice, ...VOICE_ADDONS_KINDS] },
  { config: addonVisualConfig.SHIELD, kinds: [ADDON_PRODUCT_KIND.shield, ADDON_KIND.SHIELD] },
  { config: addonVisualConfig.EASY_CARE, kinds: [ADDON_PRODUCT_KIND.easyCare, ADDON_KIND.EASY_CARE] },
  { config: addonVisualConfig.OFFICE_HOURS, kinds: [ADDON_PRODUCT_KIND.officeHours, ADDON_KIND.OFFICE_HOURS] },
  { config: addonVisualConfig.STREAM, kinds: [ADDON_PRODUCT_KIND.viasatStream, ADDON_KIND.CONTENT_ADD_ON] },
  { config: addonVisualConfig.STATIC_IP, kinds: [ADDON_PRODUCT_KIND.staticIp, ADDON_KIND.STATIC_IP] },
  { config: addonVisualConfig.CYBER_PROTECT, kinds: [ADDON_PRODUCT_KIND.cyberProtect, ADDON_KIND.CYBER_PROTECT] },
];

const addonImagePropsByKind = config.reduce<Record<string, VisualConfig>>((accumulator, { config, kinds }) => {
  kinds.forEach((addonKind) => {
    accumulator[addonKind] = config;
  });

  return accumulator;
}, {});

export const getAddonImagePropsByKind = (kind: string) => {
  return addonImagePropsByKind[kind] ?? addonVisualConfig.DEFAULT;
};
